export default "__VITE_ASSET__CUpa$pbZ__"